import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

interface Props {
  className?: string;
  isMobile: boolean;
}

const Grid: React.FC<Props> = ({ className, isMobile }) => {
  const videoSource = [
    'example_video.mp4',
    'example_video.mp4',
    'example_video.mp4',
    'example_video.mp4',
  ];
  return (
    <div
      className={cn(className, 'relative grid pt-40 px-6 gap-16', {
        'grid-cols-2': isMobile === true,
        'grid-cols-1': isMobile === false,
      })}>
      {videoSource.map((scr, idx) => (
        <div>
          <div
            style={{ paddingTop: '100%' }}
            className="relative pt-4 rounded-2xl z-0"
            key={idx}>
            <button>
              <video
                controls
                onClick={() => {}}
                className="absolute w-full min-h-full h-auto top-0 left-0 right-0 bottom-0 m-auto object-cover rounded-2xl"
                src={scr}
                poster="example.jpg"
              />
            </button>
          </div>
          <Link to={`/tool${idx + 1}`} color="secondary" className="font-bold">
            TOOL {idx + 1}
          </Link>
        </div>
      ))}
    </div>
  );
};

export default Grid;
